import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../store/ApplicationState";
import {
  getLogin,
  getRoles,
  getUserDetails,
  getUserModified,
  getUserPermissionCall,
  putLoggedInUserDetails,
} from "../../actions/User";
import { LoggedInUserDetailsDispatchTypes } from "../../models/DispatchTypes/User";
import { UserDetailsPayload } from "../../models/User";
import Header from "../components/Header";
import { getUserModule } from "../../actions/Modules";
import { withErrorBoundary } from "../../components/custom/structure/components/ErrorBoundary";
import ErrorFallback from "../../components/custom/structure/components/ErrorFallback";
import { masterSync } from "../../actions/Master";
import { masterApiCall, resetStates } from "../../actions/Common";
import { MasterSync } from "../../models/Master";

const mapStateToProps = ({
  loggedInUserState,
  userModifiedState,
  masterSyncState
}: ApplicationState) => ({
  user: loggedInUserState.response,
  userModified: userModifiedState,
  masterSyncData : masterSyncState
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    LoggedInUserDetailsDispatchTypes
  >
) => {
  return {
    putLoggedInUserDetails: (userId: string, payload: UserDetailsPayload) => {
      dispatch(putLoggedInUserDetails(userId, payload));
    },
    getLogin: () => {
      dispatch(getLogin());
    },
    getUserModified: () => {
      dispatch(getUserModified())
    },
    getAllRoles: () => {
      dispatch(getRoles());
    },
    getUserPermission: (userId: number) => {
      dispatch(getUserPermissionCall(userId));
    },
    getUserModules: (userId: number) => {
      dispatch(getUserModule(userId));
    },
    getUserDetails: (id: number) => {
      dispatch(getUserDetails(id));
    },
    masterSync:(payload:MasterSync[])=>{
      dispatch(masterSync(payload))
    },
    resetStates: (actionType: string[]) => {
      dispatch(resetStates(actionType));
    },
    masterApiCall:(actionType: string) => {
      dispatch(masterApiCall(actionType));
    },
  };
};

const ConnectedHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

ConnectedHeader.displayName = "Header";

export default withErrorBoundary(ConnectedHeader, {
  fallback: ErrorFallback,
});